import { render, staticRenderFns } from "./advert-close-popover.vue?vue&type=template&id=58dabcc7"
import script from "./advert-close-popover.vue?vue&type=script&lang=ts"
export * from "./advert-close-popover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports